import clsx from "clsx";
import format from "date-fns/format";
import isValid from "date-fns/isValid";
import isSameDay from "date-fns/isSameDay";
import endOfWeek from "date-fns/endOfWeek";
import React, { PureComponent } from "react";
import startOfWeek from "date-fns/startOfWeek";
import isWithinInterval from "date-fns/isWithinInterval";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { createStyles } from "@material-ui/styles";
// this guy required only on the docs site to work with dynamic date library
import { IconButton, withStyles } from "@material-ui/core";
import DateFnsUtils from '@date-io/date-fns'; // choose your lib

class CustomElements extends PureComponent {
  state = {
    selectedDate: this.props.weekStart,
  };

  handleWeekChange = date => {
    this.setState({ selectedDate: startOfWeek(new Date(date), { weekStartsOn: this.props.starterDay }) });
    this.props.setWeekStart(startOfWeek(new Date(date), { weekStartsOn: this.props.starterDay }));
    this.props.acceptFn(format(startOfWeek(new Date(date), { weekStartsOn: this.props.starterDay }), 'yyyy-MM-dd'));
  };

  formatWeekSelectLabel = (date, invalidLabel) => {
    let dateClone = new Date(date);

    return dateClone && isValid(dateClone)
      ? `Week of ${format(startOfWeek(dateClone, { weekStartsOn: this.props.starterDay }), "MMM do")}`
      : invalidLabel;
  };

  renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth) => {
    const { classes } = this.props;
    let dateClone = new Date(date);
    let selectedDateClone = new Date(selectedDate);

    const start = startOfWeek(selectedDateClone, { weekStartsOn: this.props.starterDay });
    const end = endOfWeek(selectedDateClone, { weekStartsOn: this.props.starterDay });

    const dayIsBetween = isWithinInterval(dateClone, { start, end });
    const isFirstDay = isSameDay(dateClone, start);
    const isLastDay = isSameDay(dateClone, end);

    const wrapperClassName = clsx({
      [classes.highlight]: dayIsBetween,
      [classes.firstHighlight]: isFirstDay,
      [classes.endHighlight]: isLastDay,
    });

    const dayClassName = clsx(classes.day, {
      [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
      [classes.highlightNonCurrentMonthDay]: !dayInCurrentMonth && dayIsBetween,
    });

    return (
      <div className={wrapperClassName}>
        <IconButton className={dayClassName}>
          <span> {format(dateClone, "d")} </span>
        </IconButton>
      </div>
    );
  };

  render() {
    const { selectedDate } = this.state;

    return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <DatePicker
        label="Week picker"
        value={selectedDate}
        onChange={this.handleWeekChange}
        renderDay={this.renderWrappedWeekDay}
        labelFunc={this.formatWeekSelectLabel}
      />
    </MuiPickersUtilsProvider>
    );
  }
}

const styles = createStyles(theme => ({
  dayWrapper: {
    position: "relative",
  },
  day: {
    width: 36,
    height: 36,
    fontSize: theme.typography.caption.fontSize,
    margin: "0 2px",
    color: "inherit",
  },
  customDayHighlight: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: "2px",
    right: "2px",
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: "50%",
  },
  nonCurrentMonthDay: {
    color: theme.palette.text.disabled,
  },
  highlightNonCurrentMonthDay: {
    color: "#676767",
  },
  highlight: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  firstHighlight: {
    extend: "highlight",
    borderTopLeftRadius: "50%",
    borderBottomLeftRadius: "50%",
  },
  endHighlight: {
    extend: "highlight",
    borderTopRightRadius: "50%",
    borderBottomRightRadius: "50%",
  },
}));

export default withStyles(styles)(CustomElements);
